import React, { memo, useCallback } from 'react';

// Componente para campos de audio
const AudioField = memo(({ question, value, onChange, handleFileChange, error, readonly }) => {
  return (
    <div className="file-field">
      <input
        type="file"
        id={question.name}
        accept="audio/*"
        onChange={handleFileChange}
        required={question.required}
        className={error ? 'has-error' : ''}
        disabled={readonly}
      />
      {value && (
        <div style={{ marginTop: '8px', fontSize: '14px', color: '#666' }}>
          {typeof value === 'object' && value.isFile ? (
            <div>
              <div><strong>Archivo seleccionado:</strong> {value.name}</div>
              <div><strong>Tamaño:</strong> {(value.size / 1024).toFixed(1)} KB</div>
              <div><strong>Tipo:</strong> {value.type}</div>
            </div>
          ) : (
            <div>Archivo actual: {value}</div>
          )}
        </div>
      )}
    </div>
  );
});

// Componente para campos de video
const VideoField = memo(({ question, value, onChange, handleFileChange, error, readonly }) => {
  return (
    <div className="file-field">
      <input
        type="file"
        id={question.name}
        accept="video/*"
        onChange={handleFileChange}
        required={question.required}
        className={error ? 'has-error' : ''}
        disabled={readonly}
      />
      {value && (
        <div style={{ marginTop: '8px', fontSize: '14px', color: '#666' }}>
          {typeof value === 'object' && value.isFile ? (
            <div>
              <div><strong>Archivo seleccionado:</strong> {value.name}</div>
              <div><strong>Tamaño:</strong> {(value.size / 1024).toFixed(1)} KB</div>
              <div><strong>Tipo:</strong> {value.type}</div>
            </div>
          ) : (
            <div>Archivo actual: {value}</div>
          )}
        </div>
      )}
    </div>
  );
});

// Componente para campos de archivo genérico
const FileField = memo(({ question, value, onChange, handleFileChange, error, readonly }) => {
  return (
    <div className="file-field">
      <input
        type="file"
        id={question.name}
        onChange={handleFileChange}
        required={question.required}
        className={error ? 'has-error' : ''}
        disabled={readonly}
      />
      {value && (
        <div style={{ marginTop: '8px', fontSize: '14px', color: '#666' }}>
          {typeof value === 'object' && value.isFile ? (
            <div>
              <div><strong>Archivo seleccionado:</strong> {value.name}</div>
              <div><strong>Tamaño:</strong> {(value.size / 1024).toFixed(1)} KB</div>
              <div><strong>Tipo:</strong> {value.type}</div>
            </div>
          ) : (
            <div>Archivo actual: {value}</div>
          )}
        </div>
      )}
    </div>
  );
});

AudioField.displayName = 'AudioField';
VideoField.displayName = 'VideoField';
FileField.displayName = 'FileField';

export {
  AudioField,
  VideoField,
  FileField
};